/**
 * The file used for the no audio signal sound notification.
 *
 * @type {string}
 */
export const NO_AUDIO_SIGNAL_SOUND_FILE = 'noAudioSignal.mp3';
